<h2 mat-dialog-title *ngIf="!isLarge">{{'text.UpdateProfile' | translate}}</h2>
<mat-dialog-content *ngIf="!isLarge">
  <div class="info-dialog">
    <p>{{'text.NewProfileUpdate' | translate}}</p>
    <p>
      {{'text.NewFieldsAdded' | translate}}
    </p>

    <ul class="checklist">
      <li>
        <svg-icon src="assets/icons/mark-check.svg"></svg-icon>
        <span>{{ 'label.SpecializationPosition' | translate }}</span>
      </li>
      <li>        <svg-icon src="assets/icons/mark-check.svg"></svg-icon>
        <span>{{ 'label.IndustryField' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check.svg"></svg-icon>
        <span>{{ 'label.ExperienceLevel' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check.svg"></svg-icon>
        <span>{{ 'label.WorkScheduleType' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check.svg"></svg-icon>
        <span>{{ 'label.EmploymentForm' | translate }}</span></li>
    </ul>

    <p style="white-space: pre-line;">
     {{'text.FillTheFields' | translate}}
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="start" *ngIf="!isLarge">
    <button class="actions" (click)="close()">{{'label.Understood' | translate}}</button>
</mat-dialog-actions>

<h2 mat-dialog-title *ngIf="isLarge">{{'text.UpdateVacancyDetails' | translate}}</h2>
<mat-dialog-content *ngIf="isLarge">
  <div class="info-dialog">
    <p>{{'text.StepsOfVacancyUpdate' | translate}}</p>
    <p>
      {{'text.FirstStepOfVacancyUpdate' | translate}}
    </p>

    <ul class="checklist">
      <li>
        <svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'label.VacancyPositionTitle' | translate }}</span>
      </li>
      <li>
        <svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'label.WorkLocation' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'label.IndustryField' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'label.WorkScheduleType' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'label.EmploymentForm' | translate }}</span></li>
    </ul>

     <p>
     {{'text.SecondStepOfVacancyUpdate' | translate}}
    </p>

        <ul class="checklist">
      <li>
        <svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'text.RelevantWorkDescription' | translate }}</span>
      </li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'text.IndustryBackground' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'text.ExperienceLevel' | translate }}</span></li>
      <li><svg-icon src="assets/icons/mark-check-green.svg"></svg-icon>
        <span>{{ 'text.EducationStatus' | translate }}</span></li>
    </ul>

    <p>
     {{'message.NoteOnVacancyUpdate' | translate}}
    </p>

    <p>
     {{'message.FullyCompletedFields' | translate}}
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="start" *ngIf="isLarge">
    <button class="actions" (click)="close()">{{'label.Understood' | translate}}</button>
</mat-dialog-actions>
